export enum IncomeOrExpenseType {
  Income = 'income',
  Expense = 'expense',
}

export enum IncomeOrExpenseApportionmentMode {
  Single = 'single',
  Multiple = 'multiple',
}

export enum IncomeType {
  DepositInterestIncome = 'depositInterestIncome',
  DividendIncome = 'dividendIncome',
  InterestIncome = 'interestIncome',
  InterestOutsideOfCarryIncome = 'interestOutsideOfCarryIncome',
  OtherIncome = 'otherIncome',
  OtherOutsideOfCarryIncome = 'otherOutsideOfCarryIncome',
  AccruedIncome = 'accruedIncome',
}

export enum ExpenseType {
  AccountingFeeExpense = 'accountingFeeExpense',
  AdministrationFeeExpense = 'administrationFeeExpense',
  AdvisoryFeeExpense = 'advisoryFeeExpense',
  AifmFeeExpense = 'aifmFeeExpense',
  AuditFeeExpense = 'auditFeeExpense',
  BankCharges = 'bankCharges',
  ConsultancyFeeExpense = 'consultancyFeeExpense',
  CustodianFeeExpense = 'custodianFeeExpense',
  DepositoryFeeExpense = 'depositoryFeeExpense',
  DirectorsFeeExpense = 'directorsFeeExpense',
  IncentiveFeeExpense = 'incentiveFeeExpense',
  InformationTechnologyExpense = 'informationTechnologyExpense',
  InsuranceExpense = 'insuranceExpense',
  OtherExpense = 'otherExpense',
  LegalAndProfessionalFeesExpense = 'legalAndProfessionalFeesExpense',
  ManagementFee = 'managementFee',
  OperatingExpense = 'operatingExpense',
  OperationAndMaintenanceExpense = 'operationAndMaintenanceExpense',
  OrganisationExpense = 'organisationExpense',
  PlacementFeeExpense = 'placementFeeExpense',
  RegulatoryAndTaxFee = 'regulatoryAndTaxFee',
  ReimbursementFeeExpense = 'reimbursementFeeExpense',
  SecretarialFeeExpense = 'secretarialFeeExpense',
  SundryExpense = 'sundryExpense',
  TaxationExpense = 'taxationExpense',
  TravelAndEntertainmentExpense = 'travelAndEntertainmentExpense',
  InterestExpense = 'interestExpense',
  AccruedExpense = 'accruedExpense',
}

export enum IncomeOrExpenseState {
  Payable = 'payable',
  Receivable = 'receivable',
  Accrued = 'accrued',
}

export enum CustomIncomeOrExpenseType {
  CustomActionType = 'customActionType',
}

export enum IncomeOrExpenseTransactionSubType {
  AccruedIncomeDebit = 'accruedIncomeDebit',
  AccruedIncomeCredit = 'accruedIncomeCredit',
  AccruedExpenseDebit = 'accruedExpenseDebit',
  AccruedExpenseCredit = 'accruedExpenseCredit',
}
